<template>
    <div class="plateforme-page">

        <AppHead />
      <section class="hero-section">
        <div class="hero-media" aria-hidden="true">
          <img
            class="hero-media__img"
            src="@/assets/img/solutions-abstrait.png"
            width="1920"
            height="1088"
            alt=""
            fetchpriority="high"
            decoding="async"
          />
          <div class="hero-media__overlay"></div>
        </div>

        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="hero-content">
                <p class="hero-eyebrow">La plateforme</p>
                <h1 class="hero-title">Pilotez votre patrimoine en un seul endroit</h1>
                <p class="hero-lead">
                  Consolidez vos actifs, visualisez les priorités et avancez avec un conseiller dédié.
                </p>
                <div class="hero-actions">
                  <router-link
                    to="/nous-contacter?demande=demo"
                    class="btn-brand btn-brand--primary btn-lg hero-btn"
                    @click="trackCta('platform_hero', 'Demander une démo')"
                  >
                    Demander une démo
                  </router-link>
                  <router-link
                    to="/diagnostic"
                    class="btn-brand btn-brand--primary btn-lg hero-btn"
                    @click="trackCta('platform_hero', 'Faire mon diagnostic')"
                  >
                    Faire mon diagnostic
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="hero-visual">
                <div class="hero__figure">
                  <img
                    src="@/assets/img/dashboard-desk.png"
                    width="1280"
                    height="800"
                    alt="Aperçu du tableau de bord Patrimonea"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="features-section section-padding">
        <div class="container">
          <div class="features-header">
            <p class="features-eyebrow">Fonctionnalités</p>
            <h2 class="features-title">Une plateforme conçue pour piloter</h2>
            <p class="features-lead">
              Patrimonea structure vos informations patrimoniales, met en évidence les priorités et vous aide à décider avec clarté.
            </p>
          </div>
          <div class="features-grid">
            <article class="feature-card">
              <div class="feature-card__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                  <path d="M4 19V5M4 19h16" stroke-linecap="round" />
                  <path d="M7 15l3-4 3 2 4-6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <h3 class="feature-card__title">Vision consolidée</h3>
              <ul class="feature-card__list">
                <li>Consolidation de vos actifs et engagements</li>
                <li>Tableaux de bord lisibles et structurés</li>
                <li>Répartition et évolution dans le temps</li>
              </ul>
            </article>
            <article class="feature-card">
              <div class="feature-card__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                  <path d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
                  <path d="M14 3v5h5" />
                  <path d="M10 14l1.5 1.5L15 12" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <h3 class="feature-card__title">Diagnostic patrimonial</h3>
              <ul class="feature-card__list">
                <li>Lecture globale de votre situation</li>
                <li>Identification des priorités et points de vigilance</li>
                <li>Indicateurs d’aide à la décision</li>
              </ul>
            </article>
            <article class="feature-card">
              <div class="feature-card__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                  <path d="M4 12a8 8 0 0 1 13.5-5.8M20 4v4h-4" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M20 12a8 8 0 0 1-13.5 5.8M4 20v-4h4" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <h3 class="feature-card__title">Plan d’actions</h3>
              <ul class="feature-card__list">
                <li>Recommandations adaptées à vos objectifs</li>
                <li>Scénarios et arbitrages documentés</li>
                <li>Suivi dans la durée</li>
              </ul>
            </article>
          </div>
        </div>
      </section>
  
      <section class="accompaniment-section section-padding bg-light">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="accompaniment-visual">
                <div class="human-touch-card">
                  <div class="human-content">
                    <img src="@/assets/img/conseiller-patrimonial.png" width="720" height="544" alt="Conseillère patrimoniale en entretien" class="advisors-img" loading="lazy">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="accompaniment-content">
                <h2 class="section-title">Une approche digitale, encadrée par l’expertise humaine</h2>
                <p class="lead-text">
                  Patrimonea est une plateforme de pilotage patrimonial conçue pour les cadres, dirigeants et entrepreneurs.
                  Elle structure l’information, sécurise les échanges et permet d’arbitrer avec rigueur, en lien avec l’expertise de GWEM.
                </p>
                
                <div class="benefits">
                  <div class="benefit-item">
                    <div class="benefit-number">01</div>
                    <div class="benefit-content">
                      <h4>Conseiller dédié</h4>
                    </div>
                  </div>
                  <div class="benefit-item">
                    <div class="benefit-number">02</div>
                    <div class="benefit-content">
                      <h4>Échanges sécurisés</h4>

                    </div>
                  </div>
                  <div class="benefit-item">
                    <div class="benefit-number">03</div>
                    <div class="benefit-content">
                      <h4>Revues périodiques</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <section class="apercu-section section-padding">
        <div class="container">
          <div class="row align-items-center g-5">
            <div class="col-lg-5">
              <div class="apercu-content">
                <p class="apercu-eyebrow">Aperçu</p>
                <h2 class="apercu-title">Votre tableau de bord, à jour</h2>
                <p class="apercu-lead">
                  Valeur nette, répartition par classe d’actifs, échéances et recommandations en cours :
                  tout est réuni sur une seule vue, accessible depuis votre mobile.
                </p>
                <router-link
                  to="/nous-contacter?demande=demo"
                  class="apercu-link"
                  @click="trackCta('platform_apercu', 'Voir une démonstration')"
                >
                  Voir une démonstration →
                </router-link>
              </div>
            </div>
            <div class="col-lg-7">
              <div class="apercu-visual">
                <img
                  src="@/assets/img/dashboard-desk.png"
                  width="1200"
                  height="800"
                  alt="Tableau de bord patrimonial sur tablette"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="security-section section-padding">
        <div class="container security-content">
          <div class="security-header text-center">
            <p class="security-kicker">Confidentialité</p>
            <h2 class="section-title">Un cadre de gouvernance rigoureux</h2>
            <p class="security-lead">
              Un environnement de travail conçu pour protéger l’information, encadrer les accès
              et garantir la traçabilité des décisions.
            </p>
          </div>

          <div class="security-layout">
            <div class="trust-grid">
              <article class="trust-card">
                <div class="trust-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                    <rect x="5" y="11" width="14" height="10" rx="2" />
                    <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke-linecap="round" />
                  </svg>
                </div>
                <h3 class="trust-title">Protection des données</h3>
                <p class="trust-desc">Chiffrement et hébergement sécurisé.</p>
              </article>
              <article class="trust-card">
                <div class="trust-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                    <path d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
                    <path d="M14 3v5h5" />
                    <path d="M10 16h4" stroke-linecap="round" />
                  </svg>
                </div>
                <h3 class="trust-title">Accès encadrés</h3>
                <p class="trust-desc">Confidentialité et accès maîtrisés.</p>
              </article>
              <article class="trust-card">
                <div class="trust-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                    <circle cx="12" cy="8" r="3.5" />
                    <path d="M5 20a7 7 0 0 1 14 0" stroke-linecap="round" />
                  </svg>
                </div>
                <h3 class="trust-title">Conseiller dédié</h3>
                <p class="trust-desc">Un interlocuteur unique, accès nominatifs.</p>
              </article>
              <article class="trust-card">
                <div class="trust-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                    <path d="M4 12a8 8 0 0 1 13.5-5.8M20 4v4h-4" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M20 12a8 8 0 0 1-13.5 5.8M4 20v-4h4" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <h3 class="trust-title">Traçabilité</h3>
                <p class="trust-desc">Historique des échanges et des décisions.</p>
              </article>
            </div>

            <aside class="governance-card">
              <h3 class="governance-title">Notre engagement</h3>
              <span class="governance-rule" aria-hidden="true" />
              <p class="governance-text">
                La confidentialité est une exigence de notre métier. Patrimonea encadre l’accès
                aux informations patrimoniales et sécurise les échanges nécessaires au suivi,
                à l’analyse et aux décisions.
              </p>
              <p class="governance-text">
                Nous accordons une attention constante au respect des cadres réglementaires
                et à la protection de vos données, pour que chaque décision se prenne dans un
                environnement de confiance.
              </p>
            </aside>
          </div>
        </div>
      </section>

      <section class="closing-cta section-padding">
        <div class="container text-center">
          <h2 class="closing-cta__title">Prêt(e) à clarifier votre patrimoine&nbsp;?</h2>
          <span class="closing-cta__rule" aria-hidden="true" />
          <p class="closing-cta__lead">
            4 minutes. Aucune carte. Un score et 3 leviers prioritaires.
          </p>
          <router-link
            to="/diagnostic"
            class="btn-brand btn-brand--primary closing-cta__btn"
            @click="trackCta('platform_closing', 'Faire mon diagnostic')"
          >
            Faire mon diagnostic →
          </router-link>
          <div class="closing-cta__secondary">
            <router-link to="/" class="closing-cta__link">Retour à l’accueil</router-link>
          </div>
        </div>
      </section>

      <StickyCtaBar
        to="/nous-contacter?demande=demo"
        label="Demander une démo"
        location="platform_sticky"
        hint="Échange de 30 min"
      />
      <SiteFooter />
    </div>
  </template>
  
  <script>
import AppHead from '@/components/public/AppHead.vue';
import SiteFooter from '@/components/public/Footer.vue';
import StickyCtaBar from '@/components/public/StickyCtaBar.vue';
import { trackCtaClick, trackViewPlatform } from '@/utils/analytics';

  export default {
    name: 'LaPlateforme',
      components: {
    AppHead,
    SiteFooter,
    StickyCtaBar,
  },
  mounted() {
    trackViewPlatform();
  },
  methods: {
    trackCta(location, label) {
      trackCtaClick({ location, label });
    },
  },
    metaInfo() {
      return {
        title: 'La Plateforme Patrimonea - GWEM',
        meta: [
          {
            name: 'description',
            content: 'Découvrez patrimonea by Gwem : la plateforme innovante pour visualiser, analyser et optimiser votre patrimoine avec des outils intelligents et un accompagnement humain.'
          }
        ]
      }
    },
  }
  </script>
  
  <style scoped>
  .plateforme-page {
    font-family: var(--font-body);
    color: var(--brand-ink);
    background: var(--surface);
    overflow-x: clip;
  }

  /* Fallback container padding (déploiement sans Bootstrap) */
  .container {
    width: 100%;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    padding-left: clamp(16px, 4vw, 24px);
    padding-right: clamp(16px, 4vw, 24px);
  }
  
  .plateforme-page h3,
.plateforme-page h5 {
    color: var(--bank-navy);
  }

  /* Titres de section : séparateur discret (évite la multiplication de "traits") */
  .plateforme-page .section-title {
    position: relative;
    padding-bottom: 10px;
    font-family: var(--font-display);
    font-size: clamp(1.75rem, 1.35rem + 1.5vw, 2.5rem);
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 1.2;
  }

  .plateforme-page .section-title::after {
    content: '';
    display: block;
    width: 48px;
    height: 3px;
    margin: 14px auto 0;
    border-radius: 2px;
    background: linear-gradient(90deg, var(--brand-brown), var(--brand-gold));
    opacity: 0.95;
  }

  .accompaniment-content .section-title {
    color: var(--brand-brown) !important;
    -webkit-text-fill-color: var(--brand-brown);
  }

  /* Sections avec titre aligné à gauche */
  .accompaniment-content .section-title::after {
    margin-left: 0;
    margin-right: auto;
  }
  
  /* Hero Section — image brand + voile navy (P0 lisibilité) */
  .hero-section {
    background-color: var(--brand-navy-deep);
    color: var(--paper);
    padding: 5rem 0 4.5rem;
    overflow: hidden;
    position: relative;
    isolation: isolate;
    min-height: 620px;
    display: grid;
    align-items: center;
  }

  .hero-media {
    display: block;
    position: absolute;
    inset: 0;
    z-index: -2;
    overflow: hidden;
    background-color: var(--brand-navy-deep);
  }

  .hero-media__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center right;
    display: block;
  }

  .hero-media__overlay {
    position: absolute;
    inset: 0;
    z-index: -1;
    pointer-events: none;
    background: linear-gradient(
      90deg,
      rgba(1, 38, 62, 0.88) 0%,
      rgba(1, 38, 62, 0.62) 55%,
      rgba(1, 38, 62, 0.35) 100%
    );
  }

  @media (max-width: 767px) {
    .hero-media__overlay {
      background: linear-gradient(180deg, rgba(1, 38, 62, 0.75), rgba(1, 38, 62, 0.9));
    }
  }

  .hero__figure img {
    border-radius: var(--radius-card);
    box-shadow: var(--shadow-lg);
    border: 1px solid rgba(255, 255, 255, 0.14);
    display: block;
    width: 100%;
    height: auto;
  }

  /* Assurer que le contenu reste au-dessus */
  .hero-section .container {
    position: relative;
    z-index: 3;
  }

  .btn-lg {
    /* legacy class retained; brand CTAs use .btn-brand */
    padding: 16px 32px;
    font-size: 0.875rem;
    font-weight: 600;
    border-radius: var(--radius-pill);
    transition: all var(--dur-base) var(--ease);
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .hero-title {
    font-family: var(--font-display);
    font-size: clamp(1.75rem, 1.35rem + 1.5vw, 2.5rem);
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 1.15;
    color: var(--brand-brown) !important;
    -webkit-text-fill-color: var(--brand-brown);
    margin-bottom: 1rem;
    text-shadow: none;
  }

  .hero-eyebrow {
    margin: 0 0 0.65rem;
    font-family: var(--font-body);
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--brand-gold);
  }

  .hero-lead {
    margin: 0 0 1.5rem;
    font-family: var(--font-body);
    font-size: 1.05rem;
    line-height: 1.65;
    color: var(--brand-brown);
    max-width: 38ch;
  }
  
  .hero-content {
    max-width: 600px;
    padding: 0;
  }

  .hero-actions {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem;
  }

  .hero-actions .hero-btn,
.hero-actions .btn-brand--primary {
    background: var(--brand-brown) !important;
    border-color: var(--brand-brown) !important;
    color: #fff !important;
    -webkit-text-fill-color: #fff;
    text-transform: none;
    letter-spacing: 0.02em;
    height: auto;
    min-height: 48px;
    padding: 0.75rem 1.25rem;
    white-space: normal;
  }

  .hero-actions .hero-btn:hover,
.hero-actions .btn-brand--primary:hover {
    background: var(--brand-brown-light, #6e4d38) !important;
    border-color: var(--brand-brown-light, #6e4d38) !important;
    color: #fff !important;
    -webkit-text-fill-color: #fff;
    transform: translateY(-1px);
  }

  /* Features — style mockup FONCTIONNALITÉS */
  .features-section {
    background: var(--paper);
  }

  .features-header {
    max-width: 40rem;
    margin-bottom: clamp(2rem, 4vw, 3rem);
  }

  .features-eyebrow {
    margin: 0 0 0.65rem;
    font-family: var(--font-body);
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--brand-gold);
  }

  .features-title {
    font-family: var(--font-display);
    font-size: clamp(1.75rem, 1.35rem + 1.5vw, 2.5rem);
    font-weight: 600;
    color: var(--brand-brown);
    line-height: 1.2;
    margin: 0 0 0.75rem;
  }

  .features-title::after {
    content: '';
    display: block;
    width: 48px;
    height: 3px;
    margin-top: 0.85rem;
    border-radius: 2px;
    background: var(--brand-gold);
  }

  .features-lead {
    margin: 1rem 0 0;
    font-family: var(--font-body);
    font-size: 1.05rem;
    line-height: 1.65;
    color: var(--muted);
  }

  .features-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.25rem;
  }

  @media (max-width: 991px) {
    .features-grid {
      grid-template-columns: 1fr;
    }
  }

  .feature-card {
    background: var(--paper);
    border: 1px solid var(--line);
    border-radius: 16px;
    padding: 1.5rem 1.35rem;
    box-shadow: var(--shadow-sm);
  }

  .feature-card__icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: grid;
    place-items: center;
    background: var(--brand-brown-soft);
    color: var(--brand-gold-dark);
    margin-bottom: 1rem;
  }

  .feature-card__icon svg {
    width: 22px;
    height: 22px;
  }

  .feature-card__title {
    font-family: var(--font-display);
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--brand-brown);
    margin: 0 0 0.85rem;
  }

  .feature-card__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    gap: 0.55rem;
  }

  .feature-card__list li {
    position: relative;
    padding-left: 1.35rem;
    font-family: var(--font-body);
    font-size: 0.95rem;
    line-height: 1.5;
    color: var(--muted);
  }

  .feature-card__list li::before {
    content: '✓';
    position: absolute;
    left: 0;
    top: 0;
    color: var(--brand-gold);
    font-weight: 700;
  }

  /* Aperçu avant footer */
  .apercu-section {
    background: #fcfbf8;
    border-top: 1px solid var(--line);
  }

  .apercu-eyebrow {
    margin: 0 0 0.65rem;
    font-family: var(--font-body);
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--brand-gold);
  }

  .apercu-title {
    font-family: var(--font-display);
    font-size: clamp(1.75rem, 1.35rem + 1.5vw, 2.5rem);
    font-weight: 600;
    color: var(--brand-brown);
    line-height: 1.2;
    margin: 0 0 0.75rem;
  }

  .apercu-title::after {
    content: '';
    display: block;
    width: 48px;
    height: 3px;
    margin-top: 0.85rem;
    border-radius: 2px;
    background: var(--brand-gold);
  }

  .apercu-lead {
    margin: 1rem 0 1.35rem;
    font-family: var(--font-body);
    font-size: 1.05rem;
    line-height: 1.65;
    color: var(--muted);
    max-width: 38ch;
  }

  .apercu-link {
    font-family: var(--font-display);
    font-size: 1.05rem;
    color: var(--brand-brown);
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  .apercu-link:hover {
    color: var(--brand-red);
  }

  .apercu-visual img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 20px;
    box-shadow: var(--shadow-lg);
  }
  
  /* Section Styles */
  .bg-light {
    background-color: var(--bank-white);
  }

  /* Harmonisation des espacements (évite l'effet "page vide") */
  .plateforme-page .section-padding {
    padding: clamp(52px, 6vw, 84px) 0;
  }

  .plateforme-page .section-title {
    font-family: var(--font-display);
    font-weight: var(--font-weight-bold);
    font-size: var(--text-4xl);
    line-height: var(--line-snug);
    letter-spacing: var(--heading-letter-display);
  }

/* Security Section */
.security-section {
  background: var(--brand-navy);
  position: relative;
  overflow: hidden;
  color: var(--paper);
}

.security-section::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -10%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(201, 162, 39, 0.12) 0%, transparent 70%);
  border-radius: 50%;
  z-index: 0;
}

.security-content {
  position: relative;
  z-index: 1;
}

.security-header {
  max-width: 42rem;
  margin: 0 auto 2.5rem;
}

.security-section .section-title {
  font-family: var(--font-display);
  font-size: clamp(1.75rem, 1.35rem + 1.5vw, 2.5rem);
  font-weight: 600;
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff;
  margin: 0 0 0.85rem;
}

.security-section .section-title::after {
  display: none;
}

.security-kicker {
  margin: 0 0 0.65rem;
  font-family: var(--font-body);
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-size: 0.75rem;
  color: var(--brand-gold);
}

.security-lead {
  margin: 0 auto;
  font-family: var(--font-body);
  color: rgba(255, 255, 255, 0.86);
  font-size: 1.02rem;
  line-height: 1.65;
  max-width: 40rem;
}

.security-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.85fr);
  gap: 1.5rem;
  align-items: stretch;
}

.trust-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.trust-card {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(201, 162, 39, 0.22);
  border-radius: 14px;
  padding: 1.1rem 1rem;
  backdrop-filter: blur(10px);
}

.trust-icon {
  width: 28px;
  height: 28px;
  color: var(--brand-gold);
  margin-bottom: 0.65rem;
}

.trust-icon svg {
  width: 100%;
  height: 100%;
  display: block;
}

.trust-title {
  font-family: var(--font-body);
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff;
  font-weight: 700;
  margin: 0 0 0.35rem;
  font-size: 0.98rem;
}

.security-section h3.trust-title {
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff;
}

.trust-desc {
  font-family: var(--font-body);
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.5;
  font-size: 0.9rem;
  margin: 0;
}

.governance-card {
  background: #fff;
  border: none;
  border-left: 3px solid var(--brand-gold);
  border-radius: 16px;
  padding: 1.75rem 1.5rem;
  box-shadow: var(--shadow-lg);
  position: relative;
  text-align: left;
}

.governance-card::before {
  display: none;
}

.governance-title {
  font-family: var(--font-display);
  font-size: 1.45rem;
  font-weight: 600;
  color: var(--brand-navy);
  margin: 0 0 0.65rem;
}

.governance-rule {
  display: block;
  width: 40px;
  height: 3px;
  border-radius: 2px;
  background: var(--brand-gold);
  margin-bottom: 1rem;
}

.governance-text {
  font-family: var(--font-body);
  font-size: 0.95rem;
  color: color-mix(in srgb, var(--brand-navy) 78%, #64748b);
  line-height: 1.65;
  margin: 0 0 0.85rem;
}

.governance-text:last-child {
  margin-bottom: 0;
}

.closing-cta {
  background: #fff;
  padding-top: clamp(3.5rem, 6vw, 5rem);
  padding-bottom: clamp(3.5rem, 6vw, 5rem);
}

.closing-cta__title {
  margin: 0 0 0.85rem;
  font-family: var(--font-display);
  font-size: clamp(1.75rem, 1.35rem + 1.5vw, 2.5rem);
  font-weight: 600;
  color: var(--brand-brown);
}

.closing-cta__rule {
  display: block;
  width: 48px;
  height: 3px;
  margin: 0 auto 1rem;
  border-radius: 2px;
  background: var(--brand-gold);
}

.closing-cta__lead {
  margin: 0 auto 1.5rem;
  max-width: 32rem;
  font-family: var(--font-body);
  font-size: 1rem;
  color: var(--muted);
  line-height: 1.55;
}

.closing-cta__btn {
  background: var(--brand-gold) !important;
  border-color: var(--brand-gold) !important;
  color: var(--brand-brown) !important;
  text-transform: none;
  letter-spacing: 0.02em;
}

.closing-cta__btn:hover {
  background: color-mix(in srgb, var(--brand-gold) 88%, #000) !important;
  border-color: color-mix(in srgb, var(--brand-gold) 88%, #000) !important;
  color: var(--brand-brown) !important;
}

.closing-cta__secondary {
  margin-top: 1rem;
}

.closing-cta__link {
  font-family: var(--font-body);
  font-size: 0.95rem;
  color: var(--brand-navy);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.closing-cta__link:hover {
  color: var(--brand-brown);
}

@media (max-width: 991px) {
  .security-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 575px) {
  .trust-grid {
    grid-template-columns: 1fr;
  }
}

/* ≤ 966px : une colonne,
figure masquée,
scrim vertical */
@media (max-width: 966px) {
  .hero-section {
    padding-top: max(2.5rem, calc(env(safe-area-inset-top, 0px) + 5.25rem));
  }

  .hero-media__overlay {
    background: linear-gradient(180deg, rgba(1, 38, 62, 0.75), rgba(1, 38, 62, 0.9));
  }

  .hero-visual {
    display: none;
  }

  .hero-content {
    max-width: 640px;
    margin: 0 auto;
    text-align: center;
  }

  .hero-actions {
    justify-content: center;
  }

  .btn-lg {
    box-shadow: var(--shadow-gold);
  }
}

/* Responsive */
@media (max-width: 992px) {
  .hero-section {
    padding-top: max(2.5rem, calc(env(safe-area-inset-top, 0px) + 5.25rem));
    padding-bottom: 60px;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding-top: max(2.25rem, calc(env(safe-area-inset-top, 0px) + 5rem));
    padding-bottom: 48px;
  }
  
  .hero-title {
    font-size: 1.8rem;
    line-height: 1.2;
    margin-bottom: 1rem;
  }
  
  .hero-content h4 {
    font-size: 1rem;
    line-height: 1.5;
    margin-bottom: 1.5rem;
  }
  
  .benefit-item {
    margin-bottom: 24px;
  }
}

@media (max-width: 480px) {
  .hero-section {
    padding-top: max(1.75rem, calc(env(safe-area-inset-top, 0px) + 4.75rem));
    padding-bottom: 32px;
  }
  
  .hero-title {
    font-size: 1.5rem;
    margin-bottom: 0.75rem;
  }
  
  .hero-content h4 {
    font-size: 0.9rem;
    line-height: 1.4;
    margin-bottom: 1.25rem;
  }
  
  .btn-lg {
    padding: 12px 20px;
    font-size: 0.85rem;
    width: 100%;
    justify-content: center;
    text-align: center;
  }
  
  .section-padding {
    padding: 40px 0;
  }
  
  .section-title {
    font-size: 1.6rem;
  }
  
  .benefit-number {
    width: 44px;
    height: 44px;
    font-size: 1.1rem;
  }
  
  .benefit-content h4 {
    font-size: 1.15rem;
  }
  
  .human-touch-card {
    height: 250px;
  }
}

@media (max-width: 360px) {
  .hero-title {
    font-size: 1.4rem;
  }
  
  .hero-content h4 {
    font-size: 0.95rem;
  }
  
  .btn-lg {
    padding: 11px 20px;
    font-size: 0.9rem;
  }
  
  .section-title {
    font-size: 1.4rem;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .section-title {
    font-size: 2.2rem;
  }
  .lead-text {
    font-size: 1rem;
  }
}
  
  /* Accompaniment Section */
  .human-touch-card {
    background: linear-gradient(135deg, var(--bank-primary) 0%, var(--bank-gold) 100%);
    color: var(--bank-white);
    border-radius: 20px;
    padding: 40px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    gap: 25px;
  }
  
  .human-content {
    width: 100%;
    height: 100%;
    position: relative;
  }
  
  .lead-text {
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.6;
    color: var(--bank-gray-800);
    margin-bottom: 40px;
  }
  
  .benefits {
    margin-top: 40px;
  }
  
  .benefit-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 40px;
  }
  
  .benefit-number {
    background: linear-gradient(135deg, var(--bank-primary) 0%, var(--bank-gold) 100%);
    color: var(--bank-white);
    width: 50px;
    height: 50px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 700;
    margin-right: 20px;
    flex-shrink: 0;
  }
  
  .benefit-content h4 {
    color: var(--bank-gray-900);
    margin-bottom: 10px;
    font-size: 1.3rem;
  }
  
  .benefit-content p {
    color: var(--bank-gray-600);
    line-height: 1.6;
  }
  
  /* Accompaniment Visual Card */
  .human-touch-card {
    position: relative;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: var(--shadow-xl);
    border: 1px solid var(--bank-gray-200);
    height: 450px;
  }
  
  .advisors-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
  }
  
  .human-touch-card:hover .advisors-img {
    transform: scale(1.05);
  }
  
  @media (max-width: 1024px) {
    .human-touch-card {
      height: 350px;
    }
  }

  @media (max-width: 768px) {
    .human-touch-card {
      height: 280px;
      margin-bottom: 40px;
    }

    .section-title {
      font-size: 1.5rem;
    }
  }
  
  </style>
